export function isMobileBrowser() {
	var userAgent = navigator.userAgent;
	return isAndroid(userAgent) || isIos(userAgent);
}

export function isIos(userAgent) {
	return /CriOS/i.test(userAgent) || /iPhone/i.test(userAgent) || isIpad(userAgent);
}

export function isFirefoxOnAndroid() {
	var userAgent = navigator.userAgent;
	return isAndroid(userAgent) && userAgent.match(/Firefox/);
}

export const useDevice = () => {
	const isChromeOnAppleDevice = Boolean(navigator.userAgent.match(/CriOS/));
	const isFirefoxOnAppleDevice = Boolean(navigator.userAgent.match(/FxiOS/));
	const isOperaTouchOnAppleDevice = Boolean(navigator.userAgent.match(/OPT/));

	return {
		isChromeOnAppleDevice,
		isFirefoxOnAppleDevice,
		isOperaTouchOnAppleDevice,
	};
};

function isIpad(userAgent) {
	return (/iPad/i.test(userAgent) /* iOS pre 13 */ ||
		(/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1) /* iPad OS 13 */);
}

function isAndroid(userAgent) {
	return /Android/i.test(userAgent);
}

export function blobToBase64(blob) {
	return new Promise((resolve, _) => {
		const reader = new FileReader();
		reader.onloadend = () => resolve(reader.result);
		reader.readAsDataURL(blob);
	});
}
